const EmptyState = ({ type }) => (
    <div className="text-center py-5">
        <div className="mb-4">
            <i
                className="fas fa-video"
                style={{
                    fontSize: '48px',
                    color: 'rgba(255, 255, 255, 0.3)',
                    marginBottom: '16px',
                }}
            ></i>
        </div>
        <h5 className="text-muted mb-2">No {type} found</h5>
        <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
            Try adjusting your search terms or browse all {type}
        </p>
    </div>
)

export default EmptyState
